import React, { Fragment } from 'react'

const Dates = ({ item, index, text }) => (
  <Fragment className="dates">
    <dt>{`${text} ${index + 1}`}</dt>
    <dd>{item}</dd>
  </Fragment>
)

const CCRInterest = ({ item, account, pageJson, translations, translateWordForOption }) => {
  if (item !== undefined) {
    return (
      <div className="cc-detail-container gdocs-mleft-25">
        <div className="cc-detail-container__heading">{translations(pageJson.accordion5)}</div>
        <div className="cc-detail-container__content">
          <dl className="cc-detail-container__horizontal-row">
            {
              item.ccrRefId !== undefined
                ? [
                  <dt>{translations(pageJson.ccrRef)}</dt>,
                  <dd>{`${item.ccrRefId} ${account !== undefined && account.currency !== undefined ? account.currency.name : ''}`}</dd>
                ]
                : null
            }
            {
              item.interestPeriod !== undefined && item.interestPeriod.frequencyType !== undefined
                ? [
                  <dt>{translations(pageJson.interestPeriod)}</dt>,
                  <dd>{item.interestPeriod.frequencyType.name}</dd>
                ]
                : null
            }
            {
              item.interestPeriod !== undefined && item.interestPeriod.frequencyType !== undefined && item.interestPeriod.frequencyType.name == 'Weekly'
                ? [
                  <dt>{translations(pageJson.textSettlementDate)}</dt>,
                  <dd>{item.interestPeriod.frequencyDetails.name}</dd>
                ]
                : null
            }

            {
              item.interestPeriod !== undefined && item.interestPeriod.frequencyType !== undefined && item.interestPeriod.frequencyType.name === 'Quarterly'
                ? [
                  <dt>{translations(pageJson.textSettlementDate)}</dt>,
                  <dd>{item.interestPeriod.frequencyDetails.name}</dd>
                ]
                : null
            }

            {
              item.interestPeriod !== undefined && item.interestPeriod.frequencyType !== undefined && item.interestPeriod.frequencyType.name === 'Monthly'
                ? item.interestPeriod !== undefined && item.interestPeriod.frequencyType !== undefined && item.interestPeriod.frequencyType.name === 'Monthly' && item.interestPeriod.frequencyDetails !== undefined && item.interestPeriod.frequencyDetails.name !== undefined && item.interestPeriod.frequencyDetails.name === 'Specific day'
                  ?
                  [
                    <dt>{translateWordForOption(pageJson.settlementDate)[0]}</dt>,
                    <dd>{item.interestPeriod.frequencyDetails.name}</dd>,
                    <dt>{'Choose Day'}</dt>,
                    <dd>{item.interestPeriod.frequencyDetailValue.name}</dd>
                  ]
                  :
                  [
                    <dt>{translateWordForOption(pageJson.settlementDate)[0]}</dt>,
                    <dd>{item.interestPeriod.frequencyDetails.name}</dd>
                  ]
                : null

            }
            {
              item.interestPeriod !== undefined && item.interestPeriod.frequencyType !== undefined && item.interestPeriod.frequencyType.name === 'Calender Date'
                ? item.interestPeriod.dates.filter(item => item !== '').map((item, i) => <Dates item={item} index={i} text={translateWordForOption(pageJson.settlementDate)[0]} />)
                : null
            }
            {
              item.interestPeriod !== undefined && item.interestPeriod.frequencyType !== undefined && item.interestPeriod.frequencyType.name === 'Annually'
                ? [
                  <dt>{translateWordForOption(pageJson.settlementDate)[0]}</dt>,
                  <dd>{item.interestPeriod.annualDate}</dd>
                ]
                : null
            }
            {
              item.settlementType !== undefined
                ? [
                  <dt>{translations(pageJson.settlementType)}</dt>,
                  <dd>{item.settlementType.name}</dd>
                ]
                : null
            }
            <dt>{translations(pageJson.ccrRate)}</dt>
            <dd>&nbsp;</dd>

            <dt>{translations(pageJson.interestEarnings)}</dt>
            <dd>
              {
                item.interestEarnings && item.interestEarnings.interestRateType === 'fixedRate'
                  ? translateWordForOption(pageJson.setBaseRate)[1]
                  : translateWordForOption(pageJson.setBaseRate)[0]
              }
              <div>
                {
                  item.interestEarnings && item.interestEarnings.interestRateType === 'fixedRate'
                    ? <dl>
                      <dt>{translateWordForOption(pageJson.setBaseRate)[7]}</dt>
                      <dd>
                        {
                          item.interestEarnings !== undefined && 'fixedRateValue' in item.interestEarnings
                            ? item.interestEarnings.fixedRateValue + '%'
                            : null
                        }
                      </dd>
                    </dl>
                    : <dl>
                      {
                        item.interestEarnings !== undefined && 'interestEarnings' in item && 'baseRate' in item.interestEarnings
                          ? [
                            <dt>{translateWordForOption(pageJson.setBaseRate)[2]}</dt>,
                            <dd>{item.interestEarnings.baseRate}</dd>
                          ]
                          : null
                      }
                      {
                        item.interestEarnings !== undefined && 'interestEarnings' in item && 'baseRateCode' in item.interestEarnings
                          ? [
                            <dt>{translateWordForOption(pageJson.setBaseRate)[3]}</dt>,
                            <dd>{item.interestEarnings.baseRateCode}</dd>
                          ]
                          : null
                      }
                      {
                        item.interestEarnings !== undefined && 'interestEarnings' in item && 'spread' in item.interestEarnings
                          ? [
                            <dt>{translateWordForOption(pageJson.setBaseRate)[4]}</dt>,
                            <dd>{item.interestEarnings.spread}</dd>
                          ]
                          : null
                      }
                      <dt>&nbsp;</dt>
                      <dd>
                        {
                          item.interestEarnings !== undefined && item.interestEarnings.rate === 'marginBaseRate'
                            ? translateWordForOption(pageJson.setBaseRate)[5]
                            : translateWordForOption(pageJson.setBaseRate)[6]
                        }
                      </dd>
                    </dl>
                }
              </div>
            </dd>
            <dt>{translations(pageJson.interestCharges)}</dt>
            <dd>
              {
                item.interestCharges && item.interestCharges.interestRateType === 'fixedRate'
                  ? translateWordForOption(pageJson.setBaseRate)[1]
                  : translateWordForOption(pageJson.setBaseRate)[0]
              }
              <div>
                {
                  item.interestCharges && item.interestCharges.interestRateType === 'fixedRate'
                    ? <dl>
                      <dt>{translateWordForOption(pageJson.setBaseRate)[7]}</dt>
                      <dd>
                        {
                          item.interestCharges !== undefined && 'fixedRateValue' in item.interestCharges
                            ? item.interestCharges.fixedRateValue + '%'
                            : null
                        }
                      </dd>
                    </dl>
                    : <dl>
                      {
                        item.interestCharges !== undefined && 'interestCharges' in item && 'baseRate' in item.interestCharges
                          ? [
                            <dt>{translateWordForOption(pageJson.setBaseRate)[2]}</dt>,
                            <dd>{item.interestCharges.baseRate}</dd>
                          ]
                          : null
                      }
                      {
                        item.interestCharges !== undefined && 'interestCharges' in item && 'baseRateCode' in item.interestCharges
                          ? [
                            <dt>{translateWordForOption(pageJson.setBaseRate)[3]}</dt>,
                            <dd>{item.interestCharges.baseRateCode}</dd>
                          ]
                          : null
                      }
                      {
                        item.interestCharges !== undefined && 'interestCharges' in item && 'spread' in item.interestCharges
                          ? [
                            <dt>{translateWordForOption(pageJson.setBaseRate)[4]}</dt>,
                            <dd>{item.interestCharges.spread}</dd>
                          ]
                          : null
                      }
                      <dt>&nbsp;</dt>
                      <dd>
                        {
                          item.interestCharges !== undefined && item.interestCharges.rate === 'marginBaseRate'
                            ? translateWordForOption(pageJson.setBaseRate)[5]
                            : translateWordForOption(pageJson.setBaseRate)[6]
                        }
                      </dd>
                    </dl>
                }
              </div>
            </dd>
            {
              item.openingLoanPosition !== undefined && item.openingLoanPosition !== ''
                ? [
                  <dt>{translations(pageJson.openingLoanPosition)}</dt>,
                  <dd>{item.openingLoanPosition}</dd>
                ]
                : null
            }
            {
              item.openingAccuredInterest !== undefined && item.openingAccuredInterest !== ''
                ? [
                  <dt>{translations(pageJson.openingAccruedInterest)}</dt>,
                  <dd>{item.openingAccuredInterest}</dd>
                ]
                : null
            }
            <dt>{translations(pageJson.tiering)}</dt>
            <dd>{item.tiering === true ? 'Yes' : 'No'}</dd>

            {
              item.resetFrequency !== undefined
                ? [
                  <dt>{translations(pageJson.resetFrequency)}</dt>,
                  <dd>{item.resetFrequency !== undefined ? item.resetFrequency.name : ''}</dd>
                ]
                : null
            }
            {
              item.csrAppliedInterestEarnings !== undefined && 'csrAppliedInterestEarnings' in item
                ? [
                  <dt>{translations(pageJson.appliedInterestEarnings)}</dt>,
                  <dd>{item.csrAppliedInterestEarnings + '%'}</dd>
                ]
                : null
            }
            {
              item.csrAppliedInterestCharges !== undefined && 'csrAppliedInterestCharges' in item
                ? [
                  <dt>{translations(pageJson.appliedInterest)}</dt>,
                  <dd>{item.csrAppliedInterestCharges + '%'}</dd>
                ]
                : null
            }
            {
              item.gross !== undefined
                ? [
                  <dt>{translations(pageJson.netCalculation)}</dt>,
                  <dd>{item.gross}</dd>
                ]
                : null
            }
          </dl>
        </div>
      </div>
    )
  } else {
    return null;
  }
}
export default CCRInterest;



// WEBPACK FOOTER //
// ./src/components/CaseList/PreviewGLS/CCPreview/SweepInstruction/CCRInterest.js